"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getLineData = exports.createProsemirrorDoc = void 0;
const codex_1 = require("@showrunner/codex");
const prosemirror_model_1 = require("prosemirror-model");
// weak types here are direct from prosemirror-model
// eslint-disable-next-line @typescript-eslint/no-explicit-any
const createProsemirrorDoc = (json) => 
// eslint-disable-next-line @typescript-eslint/no-unsafe-argument
prosemirror_model_1.Node.fromJSON(codex_1.schema, json);
exports.createProsemirrorDoc = createProsemirrorDoc;
const getId = (node) => {
    const rawId = node.attrs.id;
    if (typeof rawId === 'string' && rawId.length > 0) {
        return rawId;
    }
    return 'no-id';
};
const getLineData = (doc) => {
    const lines = [];
    doc.descendants((node) => {
        if (node.isTextblock) {
            const id = getId(node);
            const blockType = node.type.name;
            lines.push({
                id,
                blockType,
                text: node.textContent,
            });
            return false;
        }
    });
    return lines;
};
exports.getLineData = getLineData;
